import { container } from '../../../container';
import { DEPENDENCIES } from '../../../container/dependencies.const';
import { PositionService } from '../../../services';
import { CORE_ACTIONS_KEYS, CORE_MUTATIONS_KEYS } from '../core.const';
import { CoreAction, CoreContext } from '../core.interfaces';

export class CalculateCoreStylesAction implements CoreAction {
  actions = {
    [CORE_ACTIONS_KEYS.calculateCorePosition]: ({ commit }: CoreContext) => {
      const positionServices: PositionService[] = this.getPositionServices();
      const position = this.getPosition(positionServices);
      commit(CORE_MUTATIONS_KEYS.setCoreStyles, position);
    }
  };

  private getPositionServices(): PositionService[] {
    return container.getAll<PositionService>(DEPENDENCIES.PositionService);
  }

  private getPosition(positionServices: PositionService[]): {} {
    return positionServices.reduce((position, positionService) => positionService.getCorePosition(position), {});
  }
}
